var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorporate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4689 21.328C32.9255 21.328 32.4845 20.8874 32.4845 20.3437V13.1352L26.5411 10.7575C26.0361 10.5557 25.7907 9.98272 25.9925 9.47803C26.1944 8.97334 26.7686 8.72854 27.2717 8.92977L33.8342 11.5548C34.2085 11.7041 34.4533 12.0662 34.4533 12.4686V20.3436C34.4533 20.8874 34.0124 21.328 33.4689 21.328Z",
    fill: "url(#paint0_linear_84_6175)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5938 39.7031H3.28125C2.7378 39.7031 2.29688 39.2625 2.29688 38.7188V3.28125C2.29688 2.73747 2.7378 2.29688 3.28125 2.29688H26.9062C27.4497 2.29688 27.8906 2.73747 27.8906 3.28125V20.3438C27.8906 20.8875 27.4497 21.3281 26.9062 21.3281C26.3628 21.3281 25.9219 20.8875 25.9219 20.3438V4.26562H4.26562V37.7344H25.5938C26.1372 37.7344 26.5781 38.175 26.5781 38.7188C26.5781 39.2625 26.1372 39.7031 25.5938 39.7031Z",
    fill: "url(#paint1_linear_84_6175)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 39.7031C19.144 39.7031 18.7031 39.2625 18.7031 38.7188V31.1719H11.4844V38.7188C11.4844 39.2625 11.0435 39.7031 10.5 39.7031C9.95655 39.7031 9.51562 39.2625 9.51562 38.7188V30.1875C9.51562 29.6437 9.95655 29.2031 10.5 29.2031H19.6875C20.231 29.2031 20.6719 29.6437 20.6719 30.1875V38.7188C20.6719 39.2625 20.231 39.7031 19.6875 39.7031Z",
    fill: "url(#paint2_linear_84_6175)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0938 39.7031C14.5503 39.7031 14.1094 39.2625 14.1094 38.7188V34.125C14.1094 33.5812 14.5503 33.1406 15.0938 33.1406C15.6372 33.1406 16.0781 33.5812 16.0781 34.125V38.7188C16.0781 39.2625 15.6372 39.7031 15.0938 39.7031Z",
    fill: "url(#paint3_linear_84_6175)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7969 26.5781H7.54688C7.00342 26.5781 6.5625 26.1375 6.5625 25.5938V19.6875C6.5625 19.1437 7.00342 18.7031 7.54688 18.7031H12.7969C13.3403 18.7031 13.7812 19.1437 13.7812 19.6875V25.5938C13.7812 26.1375 13.3403 26.5781 12.7969 26.5781ZM8.53125 24.6094H11.8125V20.6719H8.53125V24.6094Z",
    fill: "url(#paint4_linear_84_6175)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6406 26.5781H17.3906C16.8472 26.5781 16.4062 26.1375 16.4062 25.5938V19.6875C16.4062 19.1437 16.8472 18.7031 17.3906 18.7031H22.6406C23.1841 18.7031 23.625 19.1437 23.625 19.6875V25.5938C23.625 26.1375 23.1841 26.5781 22.6406 26.5781ZM18.375 24.6094H21.6562V20.6719H18.375V24.6094Z",
    fill: "url(#paint5_linear_84_6175)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6406 15.4219H17.3906C16.8472 15.4219 16.4062 14.9813 16.4062 14.4375V8.53125C16.4062 7.98747 16.8472 7.54688 17.3906 7.54688H22.6406C23.1841 7.54688 23.625 7.98747 23.625 8.53125V14.4375C23.625 14.9813 23.1841 15.4219 22.6406 15.4219ZM18.375 13.4531H21.6562V9.51562H18.375V13.4531Z",
    fill: "url(#paint6_linear_84_6175)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7969 15.4219H7.54688C7.00342 15.4219 6.5625 14.9813 6.5625 14.4375V8.53125C6.5625 7.98747 7.00342 7.54688 7.54688 7.54688H12.7969C13.3403 7.54688 13.7812 7.98747 13.7812 8.53125V14.4375C13.7812 14.9813 13.3403 15.4219 12.7969 15.4219ZM8.53125 13.4531H11.8125V9.51562H8.53125V13.4531Z",
    fill: "url(#paint7_linear_84_6175)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 35.1094H10.5C9.95655 35.1094 9.51562 34.6688 9.51562 34.125C9.51562 33.5812 9.95655 33.1406 10.5 33.1406H19.6875C20.231 33.1406 20.6719 33.5812 20.6719 34.125C20.6719 34.6688 20.231 35.1094 19.6875 35.1094Z",
    fill: "url(#paint8_linear_84_6175)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4219 34.1921V35.4375C36.4219 35.9812 35.981 36.4218 35.4375 36.4218C34.894 36.4218 34.4531 35.9812 34.4531 35.4375V34.5096C33.4692 34.6284 32.4847 34.6934 31.5 34.6934C30.5153 34.6934 29.5308 34.6284 28.5469 34.5096V35.4375C28.5469 35.9812 28.106 36.4218 27.5625 36.4218C27.019 36.4218 26.5781 35.9812 26.5781 35.4375V34.1921C25.4824 33.9713 24.3883 33.6765 23.2969 33.3096V37.4062C23.2969 38.6726 24.3274 39.7031 25.5938 39.7031H37.4062C38.6726 39.7031 39.7031 38.6726 39.7031 37.4062V33.3096C38.6117 33.6765 37.5176 33.9713 36.4219 34.1921Z",
    fill: "url(#paint9_linear_84_6175)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3065 31.2318C28.7436 33.2178 34.2564 33.2178 39.6935 31.2318C39.6967 31.2306 39.7 31.2304 39.7031 31.2293V28.875C39.7031 27.6086 38.6726 26.5781 37.4062 26.5781H37.0781V25.5938C37.0781 23.9653 35.7535 22.6406 34.125 22.6406H28.875C27.2465 22.6406 25.9219 23.9653 25.9219 25.5938V26.5781H25.5938C24.3274 26.5781 23.2969 27.6086 23.2969 28.875V31.2293C23.3 31.2304 23.3033 31.2306 23.3065 31.2318ZM27.8906 25.5937C27.8906 25.0509 28.3322 24.6094 28.875 24.6094H34.125C34.6678 24.6094 35.1094 25.0509 35.1094 25.5937V26.5781H27.8906V25.5937Z",
    fill: "url(#paint10_linear_84_6175)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_84_6175",
    x1: 29.9595,
    y1: -4.73948,
    x2: 40.1843,
    y2: 13.1804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_84_6175",
    x1: 14.4095,
    y1: -38.5,
    x2: 45.0845,
    y2: 15.2594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_84_6175",
    x1: 14.7955,
    y1: 17.7514,
    x2: 21.2713,
    y2: 35.3754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_84_6175",
    x1: 15.0411,
    y1: 25.9833,
    x2: 21.0814,
    y2: 30.6248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_84_6175",
    x1: 9.97889,
    y1: 10.1143,
    x2: 15.3875,
    y2: 22.8134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_84_6175",
    x1: 19.8226,
    y1: 10.1143,
    x2: 25.2312,
    y2: 22.8134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_84_6175",
    x1: 19.8226,
    y1: -1.04194,
    x2: 25.2312,
    y2: 11.6572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_84_6175",
    x1: 9.97889,
    y1: -1.04194,
    x2: 15.3875,
    y2: 11.6572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_84_6175",
    x1: 14.7955,
    y1: 30.9934,
    x2: 15.0527,
    y2: 34.7264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_84_6175",
    x1: 31.0614,
    y1: 26.3365,
    x2: 32.8726,
    y2: 38.2412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_84_6175",
    x1: 31.0614,
    y1: 11.6462,
    x2: 35.4176,
    y2: 29.8059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/Corporate.2e5910a06642746e6cae1e2622edfa06.svg";
export { ForwardRef as ReactComponent };